<template lang="pug">
.homepageShowcaseBlockComponent(
  v-if="model"
  :class="blockClasses"
  :style="backgroundStyles"
)
  .sectionContainer
    .left
      .title(v-if="model.title") {{ model.title }}
      .features(v-if="model.features")
        .item(v-for="item in model.features") {{ item }}
      .flow(v-if="model.flow")
        .item(v-for="(item, i) in model.flow") {{ item }}
          .arrow(v-if="i !== model.flow.length - 1")
            ui-svg-icon(name="arrow-left")
      .review(v-if="model.review")
        .header
          .avatar
            ui-avatar(:url="model.review.avatar")
          .name {{ model.review.name }}
          .occupation {{ model.review.occupation}}
        .text «{{ model.review.text }}»
    .right
      .imageWrap(data-aos="zoom-in")
        img.image(
          v-if="model.image.src"
          :src="model.image.src"
        )
        .iconWrap(
          v-if="model.image.icon"
          :style="imageIconStyles"
        )
          img.icon(:src="model.image.icon")
      .showcase(v-if="model.showcase")
        .item(v-if="model.emblem")
          .emblem
            img.img(src="assets/images/home/school-emblem.svg")
            .hint По системе «Школа России»
        .item(v-for="item in model.showcase")
          .icon
            ui-svg-icon(name="lamp")
          .text {{ item }}
    .bottom(v-if="hasButton")
      a.button(href="#purchase")
        ui-button(color="orange") Попробовать
</template>

<script>
import { computed } from 'vue'
export default {
  props: {
    model: {
      type: Object,
      default: null
    },
    // default | pink | blue | orange | darkblue
    colorScheme: {
      type: String,
      default: 'default'
    },
    isReverse: Boolean,
    hasButton: Boolean,
    cursor: {
      type: Object,
      default: () => ({ x: 0, y: 0 })
    }
  },

  setup (props) {
    const blockClasses = computed(() => {
      return [
        `_${props.model.id}`,
        {
          _pink: props.colorScheme === 'pink',
          _blue: props.colorScheme === 'blue',
          _orange: props.colorScheme === 'orange',
          _darkblue: props.colorScheme === 'darkblue',
          _reverse: props.isReverse
        }
      ]
    })

    const backgroundStyles = computed(() => {
      const styles = {}
      if (props.model.background) styles.backgroundImage = `url(${props.model.background})`
      return styles
    })

    const imageIconStyles = computed(() => ({
      margin: `${props.cursor.y * 30}px -${props.cursor.x * 30}px`
    }))

    return {
      blockClasses,
      backgroundStyles,
      imageIconStyles
    }
  }
}
</script>

<style lang="sass" scoped>
.homepageShowcaseBlockComponent
  padding-top: 20*$u
  padding-bottom: 20*$u
  background-size: auto 100%
  background-repeat: no-repeat
  background-position: top left
  > .sectionContainer
    display: grid
    grid-template-areas: "left right" "bottom bottom"
    grid-template-columns: 1fr 1fr
    grid-gap: 0 2*$appSidePaddingDesktop

    > .left
      grid-area: left

      > .title
        font-family: GolosTextWebBold, serif
        font-style: normal
        font-weight: bold
        font-size: 47px
        line-height: 120%
        color: $cDarkBlue
        margin-bottom: 9*$u

      > .features
        margin-bottom: 15*$u
        max-width: 460px
        @media (max-width: $XLWidth)
          max-width: initial

        > .item
          font-family: GolosTextWebDemiBold, serif
          font-style: normal
          font-weight: 600
          font-size: 16px
          line-height: 19px
          color: #000000
          position: relative
          padding-left: 26px

          &:not(:last-child)
            margin-bottom: 6*$u

          &::before
            content: '•'
            font-size: 40px
            position: absolute
            top: 0
            left: 0
            line-height: 10px

      > .flow
        display: flex
        align-items: center
        flex-wrap: wrap
        margin: -5*$u

        > .item
          font-family: GolosTextWebDemiBold, serif
          font-style: normal
          font-weight: 600
          font-size: 16px
          line-height: 19px
          color: #000000
          margin: 5*$u
          width: min-content
          display: flex
          align-items: center

          > .arrow
            width: 8*$u
            height: 8*$u
            flex: 0 0 8*$u
            transform: rotate(180deg)
            margin-left: 5*$u

      > .review
        max-width: 400px
        margin-top: 15*$u
        background-color: #FFFFFF
        padding: 5*$u
        border-radius: 14px
        box-shadow: 6px 9px 15px rgba(0, 0, 0, 0.12)
        @media (max-width: $XLWidth)
          max-width: initial

        > .header
          display: grid
          grid-template-areas: "avatar name" "avatar occupation"
          grid-template-columns: 60px 1fr
          grid-gap: 0 3*$u
          align-items: center
          margin-bottom: 4*$u

          > .avatar
            grid-area: avatar
            width: 60px
            height: 60px

          > .name
            grid-area: name
            font-family: GolosTextWebRegular, serif
            font-style: normal
            font-weight: normal
            font-size: 16px
            line-height: 25px
            color: #565656
            margin-top: $u

          > .occupation
            grid-area: occupation
            font-family: GolosTextWebRegular, serif
            font-style: normal
            font-weight: normal
            font-size: 16px
            line-height: 25px
            color: #565656
            margin-top: -3*$u

        > .text
          font-family: GolosTextWebRegular, serif
          font-style: normal
          font-weight: normal
          font-size: 16px
          line-height: 25px
          color: #847F7F

    > .right
      grid-area: right

      > .imageWrap
        margin-bottom: 21*$u
        position: relative
        .image
          width: 100%
        .iconWrap
          position: absolute
          top: 50%
          transform: translateY(-50%)
          left: 4%
          width: 15*$u
          height: 15*$u
          display: flex
          align-items: center
          justify-content: center
          border-radius: 3*$u
          background: rgba(255, 255, 255, 0.6)
          backdrop-filter: blur(8px)
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1)
          transition: 0.05s
          .icon
            width: 8*$u

      > .showcase
        display: flex
        margin: -4*$u
        flex-wrap: wrap
        justify-content: center
        width: 130%
        transform: translateX(-10%)
        @media (max-width: $XXXLWidth)
          width: initial
          transform: initial

        > .item
          display: flex
          color: $cDarkBlue
          margin: 4*$u

          > .icon
            width: 6*$u
            height: 6*$u
            flex: 0 0 6*$u
            margin-right: 2*$u

          > .text
            font-family: GolosTextWebDemiBold, serif
            font-style: normal
            font-weight: 600
            font-size: 16px
            line-height: 19px
            max-width: 55*$u

          > .emblem
            position: relative
            align-self: center
            width: 80px

            .img
              width: 100%

            .hint
              position: absolute
              display: block
              top: calc(100% + 3*#{$u})
              left: 50%
              transform: translate(-50%, 0)
              white-space: nowrap
              background: $cWhite
              border-radius: $brS
              padding: 3*$u
              font-size: 14px
              font-family: GolosTextWebRegular, serif
              color: $cBlack
              line-height: 1
              box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3)
              opacity: 0
              pointer-events: none
              transition: $animationSpeed

            &:hover
              .hint
                opacity: 1

    > .bottom
      grid-area: bottom
      padding-top: 20*$u

      > .button
        display: block
        width: fit-content
        margin: 0 auto

  &._reverse
    background-position: top right
    > .sectionContainer
      grid-template-columns: 1fr 1fr
      > .left
        grid-area: right

      > .right
        grid-area: left

  &._pink
    background-color:  #FFF6F5
  &._blue
    background-color:  #ECF4F9
  &._orange
    background-color:  #FFF6E9
  &._darkblue
    background-color: $cDarkBlue
    >.sectionContainer
      > .left
        > .title
          color: #FFFFFF
        > .features
          > .item
            color: #FFFFFF
        > .flow
          > .item
            color: #FFFFFF
        > .review
          background: #BFC7DD
          > .header
            > .name
              color: $cDarkBlue
            > .occupation
              color: $cDarkBlue
          > .text
            color: $cDarkBlue
      > .right
        > .showcase
          > .item
            color: #FFFFFF

  &._3
    > .sectionContainer
      > .right
        > .imageWrap
          .iconWrap
            top: 40%
  &._5
    > .sectionContainer
      > .right
        > .imageWrap
          .iconWrap
            top: 55%

  @media (max-width: $XXXLWidth)
    padding-top: 10*$u
    padding-bottom: 10*$u
    > .sectionContainer
      grid-gap: 10*$u
      > .left
        > .title
          font-size: 37px
      > .right
        > .imageWrap
          margin-bottom: 10*$u
      > .bottom
        padding-top: 0

  @media (max-width: $XLWidth)
    > .sectionContainer
      grid-template-columns: 100%
      grid-template-areas: "left" "right" "bottom"

    &._reverse
      > .sectionContainer
        grid-template-columns: 100%
        grid-template-areas: "right" "left" "bottom"

  @media (max-width: 640px)
    > .sectionContainer
      > .left
        > .title
          font-size: 32px

  @media (max-width: $XXSWidth)
    > .sectionContainer
      > .left
        > .title
          font-size: 28px
</style>
